import { useCallback, useContext } from "react"
import { XmppContext } from "../stream/xmppClient"
import { useAppSelector } from "../reducers/hooks"
import {
  selectActiveChat,
  selectMessageChat,
} from "../reducers/chatsSliceSelectors"
import AdHocCommands from "../api/adHocCommands"
import { Message } from "../reducers/messagesSlice"
import { useDocumentLink } from "./useDocumentLink"
import i18n from "@/lib/i18n/i18n"
import { isManualDocumentLinkingEnabled } from "@/lib/gpsDocumentLinks"

const useUnlinkDocument = (message: Message) => {
  if (!message) return undefined
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { myJid, client } = useContext(XmppContext)
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const activeChat = useAppSelector(selectActiveChat)

  const isForwarded = !!message.forwarded
  const processedMessage = isForwarded
    ? (message.forwarded ?? ({} as Message))
    : message
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const messageChat = useAppSelector(
    selectMessageChat(processedMessage, myJid.toString()),
  )

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { documentLinks, linkType } = useDocumentLink(message)

  // GPS links are read-only here: unlinking goes through wizard stanzas only.
  const hasLink =
    isManualDocumentLinkingEnabled(myJid?.getDomain()) &&
    linkType === "deliveryOrder" &&
    !!documentLinks[0]?.deliveryOrderMessageId

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const callback = useCallback(async () => {
    const link = documentLinks[0]
    if (!link) return

    const messageRoomJid = messageChat?.jid
    const triggeringRoomJid = activeChat.jid

    if (messageRoomJid) {
      try {
        await AdHocCommands.linkDocument({
          client,
          cmrMessageId: link.cmrMessageId,
          deliveryOrderMessageId: "",
          cmrFileUrl: link.cmrFileUrl,
          cmrFileName: link.cmrFileName,
          deliveryOrderFileUrl: "",
          deliveryOrderFileName: "",
          messageRoomJid,
          triggeringRoomJid,
        })
      } catch (error) {
        console.log(error)
        window.appToaster.show({
          message: i18n.t("reports.unlinkDocument.failed"),
          intent: "danger",
        })
      }
    }
  }, [documentLinks, client, activeChat, messageChat])

  return hasLink ? callback : undefined
}

export default useUnlinkDocument
